/**
 * @generated SignedSource<<f91bd829e6c7ea0095454890ccaa4c4f>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SbSharedContentModuleIconicDesign_designPageInfo$data = {
  readonly design: {
    readonly creators: ReadonlyArray<{
      readonly browsePageLinkData: {
        readonly " $fragmentSpreads": FragmentRefs<"SeoLink_linkData">;
      };
      readonly displayName: string | null;
      readonly name: string | null;
    } | null> | null;
  } | null;
  readonly " $fragmentType": "SbSharedContentModuleIconicDesign_designPageInfo";
};
export type SbSharedContentModuleIconicDesign_designPageInfo$key = {
  readonly " $data"?: SbSharedContentModuleIconicDesign_designPageInfo$data;
  readonly " $fragmentSpreads": FragmentRefs<"SbSharedContentModuleIconicDesign_designPageInfo">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SbSharedContentModuleIconicDesign_designPageInfo",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "IconicDesign",
      "kind": "LinkedField",
      "name": "design",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Creator",
          "kind": "LinkedField",
          "name": "creators",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "displayName",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "name",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "LinkData",
              "kind": "LinkedField",
              "name": "browsePageLinkData",
              "plural": false,
              "selections": [
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "SeoLink_linkData"
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "DesignPageInfo",
  "abstractKey": null
};

(node as any).hash = "08010e53e2ce56c7a3fb59ae07c5fd85";

export default node;
